import DOMPurify from 'dompurify';
import { iframeWhitelist } from '@prolaera/library';

export default function() {
  'ngInject';

  // On each node, check if it's an iframe, and if so check that the url is whitelisted
  DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName === 'iframe') {
      const src = node.attributes.src.nodeValue;
      const regex = RegExp(`^(https:)?\/\/(${iframeWhitelist.join('|')})\/`);

      if (src && src.match(regex)) {
        return;
      }

      node.parentNode.removeChild(node);
    }
  });

  const sanitizeHtml = (dirtyHtml, stripInlineStyles) => {
    const config = {
      ADD_TAGS: ['amp-iframe', 'amp-img', 'i-amphtml-sizer', 'iframe'],
      ADD_ATTR: ['decoding', 'frameborder', 'layout', 'sandbox', 'scrolling', 'target']
    };

    if (stripInlineStyles) {
      config['FORBID_ATTR'] = ['style'];
    }

    return DOMPurify.sanitize(dirtyHtml, config);
  };

  return {
    restrict: 'A',
    scope: {
      stripInlineStyles: '<',
      wysiwygContent: '<'
    },
    link: function(scope, element) {
      element[0].classList.add('wysiwyg-content');
      element[0].innerHTML = sanitizeHtml(scope.wysiwygContent, scope.stripInlineStyles);

      // update content when wysiwygContent changes
      scope.$watch(
        'wysiwygContent',
        function(newValue, oldValue) {
          if (newValue !== oldValue) {
            element[0].innerHTML = sanitizeHtml(newValue, scope.stripInlineStyles);
          }
        },
        true
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/wysiwygContent/index.js